export default "__VITE_ASSET__32998153__"